import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Add an address to the `}<inlineCode parentName="p">{`itemShippingAddresses`}</inlineCode>{` array.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"addItemShippingAddress"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`address`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#addressdraft"
          }}>{`AddressDraft`}</a><br parentName="li"></br>
          {`The address must have a key that is unique in this cart/order.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      